export enum EIntegrationsHelpLinkUrl {
  ZOOM = 'https://www.linius.com/whizzard-for-zoom-support/',
  WEBEX = '',
  TEAMS = ''
}
